import { types } from "mobx-state-tree";

export enum ModalType {
  Login = "Login",
  Settings = "Settings",
  Product = "Product",
}

const modalTypes = Object.values(ModalType);

export const PageStore = types
  .model("PageStore", {
    currentModal: types.maybe(types.enumeration(modalTypes)),
  })
  .actions((self) => ({
    openModal(modalType: ModalType) {
      self.currentModal = modalType;
    },
    closeModal() {
      self.currentModal = undefined;
    },
  }))
  .views((self) => ({
    isSettingsModalOpen: () => self.currentModal === ModalType.Settings,
    isLoginModalOpen: () => self.currentModal === ModalType.Login,
    isProductModalOpen: () => self.currentModal === ModalType.Product,
  }));

export const createPageStore = () => {
  return PageStore.create({});
};
export type TPageStore = ReturnType<typeof createPageStore>;
